<script setup>
import AppButton from '@/components/atoms/AppButton'
import AppEmptyState from '@/components/molecules/AppEmptyState'

// Takes the content's place when the hub has none to show (Figma 29796:69281 / 29796:69282): an icon on a tinted circle, a title, a line of copy and one outlined action, centred.
defineProps({
  icon: { type: String, required: true },
  // Red for a failure, blue for a page that isn't there.
  tone: { type: String, default: 'info', validator: (tone) => ['info', 'error'].includes(tone) },
  title: { type: String, required: true },
  description: { type: String, required: true },
  actionLabel: { type: String, required: true },
  actionIcon: { type: String, default: null },
})

defineEmits(['action'])

const TONES = {
  info: { circle: 'bg-blue-50', icon: 'text-tint-1' },
  error: { circle: 'bg-red-50', icon: 'text-red-500' },
}
</script>

<template>
  <!-- flex-1 takes what the tabs leave of the panel, so the state sits mid-height. -->
  <div class="flex flex-1 items-center justify-center px-4 py-8">
    <!-- The sm scale under the design's sizes: an 18px title, 14px copy and 16px between the parts (mb-2, mt-3 and mt-1 top up its 8, 4 and 12). -->
    <AppEmptyState variant="plain" size="sm" max-width="max-w-full">
      <template #image>
        <span class="mb-2 flex size-12 items-center justify-center rounded-full" :class="TONES[tone].circle">
          <Icon :icon="icon" class="size-6" :class="TONES[tone].icon" />
        </span>
      </template>

      <template #title>
        <p class="text-lg font-semibold text-gray-900" v-text="title" />
      </template>

      <template #description>
        <p class="mt-3 text-sm text-gray-500" v-text="description" />
      </template>

      <template #action>
        <AppButton variant="outlined" size="lg" class="mt-1" :leading-icon="actionIcon" @click="$emit('action')">
          {{ actionLabel }}
        </AppButton>
      </template>
    </AppEmptyState>
  </div>
</template>
